module.exports = __webpack_public_path__ + "img/dj.c13627e8.svg";